// Loading (process-state-notifications/Loading) が z-index: 9999 で機能領域を覆うため、
// それより上に置かないとロード中はホバーしてもPopperにマウスイベントが届かない。
// ag-grid のポップアップ (99999) より下に保つ。
export const SIDE_MENU_POPPER_Z_INDEX = 10000

// アイコンとPopperの間の隙間を通過する時間の猶予。
// この猶予内にPopperへ入れば、閉じる予約が開く予約に差し替わる。
export const MENU_OPEN_DELAY_MS = 100
